import React from 'react';
import { RegularText } from 'src/components';
import { Box, Checkbox, FormControlLabel, FormGroup } from '@mui/material';
import { device, pixelScaler } from 'src/themes/Metrics';

interface Props {
  data: any[];
  onCheck(values: any[]): void;
}

const itemWidth = device.width / 2 - pixelScaler(32);

export const CustomCheckBox = ({ data, onCheck }: Props) => {
  return (
    <FormGroup style={{ flexDirection: 'row', flexWrap: 'wrap' }}>
      {data.map((checkBox, index) => (
        <Box key={index.toString()} sx={{ width: itemWidth, overflow: 'hidden' }}>
          <FormControlLabel
            value={checkBox.value}
            checked={checkBox.checked}
            onChange={(event, checked) => {
              data[index].checked = checked;
              onCheck([...data]);
            }}
            control={<Checkbox name={checkBox.value} />}
            label={
              <RegularText fontSize="medium" numberOfLines={1}>
                {checkBox.text}
              </RegularText>
            }
          />
        </Box>
      ))}
    </FormGroup>
  );
};
